export default __webpack_public_path__ + "static/hac-e22e2dd383d550f828c65f39da478f06.png";